// @ts-nocheck
const mobileBuyButtons = document.getElementById('mobile-buy-buttons');
const mainBuyButton = document.getElementById('main-buy-button');

let mainButtonPosition = mainBuyButton.getBoundingClientRect().top;
let hasScrolledPast = false;

// Keep track of button position on resize
window.addEventListener('resize', () => {
  mainButtonPosition = mainBuyButton.getBoundingClientRect().top;
});

// Listen to scroll events
window.addEventListener('scroll', () => {
  const currentPosition = mainBuyButton.getBoundingClientRect().top;
  
  // If button has scrolled out of view (top is now negative or very high)
  if (currentPosition < 0 && !hasScrolledPast) {
    hasScrolledPast = true;
    showMobileButtons();
  }
  
  // If we've scrolled back up and button is visible again
  if (currentPosition > 0 && hasScrolledPast) {
    hasScrolledPast = false;
    hideMobileButtons();
  }
});

function showMobileButtons() {
  mobileBuyButtons.style.top = '46px';
}

function hideMobileButtons() {
  mobileBuyButtons.style.top = '-100px';
}

// Initialize to hidden
hideMobileButtons();